import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getUserData } from "utils/localStorage";

import {
  identifyUser,
  isNative,
  platform,
  resetUser,
  trackEvent,
  trackPageView,
} from "../utils/mixpanel";

/**
 * Hook to use Mixpanel analytics
 * @returns {Object} Mixpanel methods and properties
 */
const useMixpanel = () => {
  const { me } = useSelector((state) => state.app);
  const userData = getUserData();

  // Track an event
  const track = useCallback((eventName, properties = {}) => {
    trackEvent(eventName, properties);
  }, []);

  // Track a page view
  const trackPage = useCallback((pageName, properties = {}) => {
    trackPageView(pageName, properties);
  }, []);

  // Identify a user
  const identify = useCallback((userId, traits = {}) => {
    identifyUser(userId, traits);
  }, []);

  // Reset user identity
  const reset = useCallback(() => {
    resetUser();
  }, []);

  // If user is in ghost mode or internal user, return no-op functions
  if (userData?.ghostLogin || (me?.email && me?.email.endsWith("@vegrow.in"))) {
    return {
      track: () => {},
      trackPage: () => {},
      identify: () => {},
      reset: () => {},
      platform,
      isNative,
    };
  }

  return {
    track,
    trackPage,
    identify,
    reset,
    platform,
    isNative,
  };
};

export default useMixpanel;
